import React, { useEffect, useState } from "react";
import { Card, Table, Button, message, DatePicker, Drawer, Typography, Tabs } from "antd";
import CheckInService from "../../Services/Manage/CheckInService";
import dayjs from "dayjs";
import { CloseOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LeaveService from "../../Services/Manage/LeaveService";

const { Text } = Typography;

function AttendanceReport({ user_id, name, departmentId, addedBy, department, phone, status }) {
  console.log("Props received:", { user_id, name, departmentId, addedBy, department, phone, status })
  const [dataSource, setDataSource] = useState([]);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [breakHistory, setBreakHistory] = useState([]);
  const [summary, setSummary] = useState({ totalWorkingHours: "0h 0m", totalBreak: "0h 0m" });
  const [activeTab, setActiveTab] = useState("day");
  const [drawerDate, setDrawerDate] = useState(null);
  const [userLeaveData, setUserLeaveData] = useState([]);

  const empUid = user_id;
  const navigate = useNavigate();


  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (_, record) => {
        const rawDate = dayjs(record.date);
        return (
          <div>
            <div>{rawDate.format("dddd")}</div>
            <div style={{ color: "#888", fontSize: 12 }}>{rawDate.format("MMM D, YYYY")}</div>
          </div>
        );
      },
    },
    { title: "Working Hours (Excl. Breaks)", dataIndex: "totalWorkingHours", key: "totalWorkingHours" },
    { title: "Total Break", dataIndex: "totalBreak", key: "totalBreak" },
    { title: "Working Hours (Incl. Breaks)", dataIndex: "workingHoursWithBreak", key: "workingHoursWithBreak" },
    { title: "Total Working Hours (Incl. OT)", dataIndex: "totalWithOT", key: "totalWithOT" },
    { title: "OT (Excl. Breaks)", dataIndex: "ot", key: "ot" },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button type="primary" size="large" onClick={() => handleViewClick(record)}>
          View
        </Button>
      ),
    },
  ];
  const fetchUserLeaveData = async () => {
    try {
      const res = await LeaveService.getActiveLeave(empUid);
      if (res?.status && Array.isArray(res.data)) {
        setUserLeaveData(res.data);
      }
    } catch (error) {
      console.error("Failed to fetch user leave data:", error);
      message.error("Failed to fetch user leave data");
    }
  };


  const fetchAttendance = async (date, type = "day") => {
    try {
      let res;
      if (type === "day") {
        res = await CheckInService.getCheckInHistoryByDate(empUid, date.format("YYYY-MM-DD"));
      } else if (type === "month") {
        res = await CheckInService.getCheckInHistoryByMonth(empUid, date.format("YYYY-MM"));
      } else if (type === "year") {
        res = await CheckInService.getCheckInHistoryByYear(empUid, date.format("YYYY"));
      }

      if (res.status && res.data.length) {
        let attendanceData = type === "day" ? res.data[0]?.data || [] : res.data || [];

        if (type === "day") {
          // Single day summary
          let totalBreakSeconds = 0;
          let totalWorkingSeconds = 0;

          attendanceData.forEach((entry) => {
            const checkIn = new Date(entry.check_in_time).getTime();
            const checkOut = entry.check_out_time ? new Date(entry.check_out_time).getTime() : Date.now();
            const workSeconds = (checkOut - checkIn) / 1000;
            const breakSeconds = entry.breaks?.reduce((acc, br) => acc + (br.duration || 0), 0) || 0;

            totalBreakSeconds += breakSeconds;
            totalWorkingSeconds += Math.max(workSeconds - breakSeconds, 0);
          });

          const OTSeconds = Math.max(totalWorkingSeconds - 8 * 3600, 0);

          setSummary({
            totalWorkingHours: `${Math.floor(totalWorkingSeconds / 3600)}h ${Math.floor((totalWorkingSeconds % 3600) / 60)}m`,
            totalBreak: `${Math.floor(totalBreakSeconds / 3600)}h ${Math.floor((totalBreakSeconds % 3600) / 60)}m`,
          });

          setDataSource([
            {
              key: 1,
              date: date,
              totalWorkingHours: `${Math.floor(totalWorkingSeconds / 3600)}h ${Math.floor((totalWorkingSeconds % 3600) / 60)}m`,
              totalBreak: `${Math.floor(totalBreakSeconds / 3600)}h ${Math.floor((totalBreakSeconds % 3600) / 60)}m`,
              workingHoursWithBreak: `${Math.floor((totalWorkingSeconds + totalBreakSeconds) / 3600)}h ${Math.floor(((totalWorkingSeconds + totalBreakSeconds) % 3600) / 60)}m`,
              totalWithOT: `${Math.floor((totalWorkingSeconds + OTSeconds) / 3600)}h ${Math.floor(((totalWorkingSeconds + OTSeconds) % 3600) / 60)}m`,
              ot: `${Math.floor(OTSeconds / 3600)}h ${Math.floor((OTSeconds % 3600) / 60)}m`,
            },
          ]);
        } else {

          const grouped = {};
          attendanceData.forEach((entry) => {
            const entryDate = dayjs(entry.check_in_time).format("YYYY-MM-DD");
            if (!grouped[entryDate]) grouped[entryDate] = [];
            grouped[entryDate].push(entry);
          });

          let totalMonthWork = 0;
          let totalMonthBreak = 0;

          const summaryRows = Object.keys(grouped).map((dateKey, idx) => {
            const dayEntries = grouped[dateKey];
            let totalBreakSeconds = 0;
            let totalWorkingSeconds = 0;

            dayEntries.forEach((entry) => {
              const checkIn = new Date(entry.check_in_time).getTime();
              const checkOut = entry.check_out_time ? new Date(entry.check_out_time).getTime() : Date.now();
              const workSeconds = (checkOut - checkIn) / 1000;
              const breakSeconds = entry.breaks?.reduce((acc, br) => acc + (br.duration || 0), 0) || 0;

              totalBreakSeconds += breakSeconds;
              totalWorkingSeconds += Math.max(workSeconds - breakSeconds, 0);
            });

            totalMonthWork += totalWorkingSeconds;
            totalMonthBreak += totalBreakSeconds;

            const OTSeconds = Math.max(totalWorkingSeconds - 8 * 3600, 0);

            return {
              key: idx,
              date: dayjs(dateKey),
              totalWorkingHours: `${Math.floor(totalWorkingSeconds / 3600)}h ${Math.floor((totalWorkingSeconds % 3600) / 60)}m`,
              totalBreak: `${Math.floor(totalBreakSeconds / 3600)}h ${Math.floor((totalBreakSeconds % 3600) / 60)}m`,
              workingHoursWithBreak: `${Math.floor((totalWorkingSeconds + totalBreakSeconds) / 3600)}h ${Math.floor(((totalWorkingSeconds + totalBreakSeconds) % 3600) / 60)}m`,
              totalWithOT: `${Math.floor((totalWorkingSeconds + OTSeconds) / 3600)}h ${Math.floor(((totalWorkingSeconds + OTSeconds) % 3600) / 60)}m`,
              ot: `${Math.floor(OTSeconds / 3600)}h ${Math.floor((OTSeconds % 3600) / 60)}m`,
            };
          });

          setDataSource(summaryRows);

          setSummary({
            totalWorkingHours: `${Math.floor(totalMonthWork / 3600)}h ${Math.floor((totalMonthWork % 3600) / 60)}m`,
            totalBreak: `${Math.floor(totalMonthBreak / 3600)}h ${Math.floor((totalMonthBreak % 3600) / 60)}m`,
          });
        }
      } else {
        setDataSource([]);
        setSummary({ totalWorkingHours: "0h 0m", totalBreak: "0h 0m" });
      }
    } catch (error) {
      console.error("Failed to fetch attendance:", error);
      message.error("Failed to fetch attendance data");
    }
  };


  const handleViewClick = (record) => {
    const recordDate = dayjs(record.date);
    setDrawerDate(recordDate);
    fetchHistoryByDate(recordDate);
  };

  const fetchHistoryByDate = async (date) => {
    try {
      const res = await CheckInService.getCheckInHistoryByDate(empUid, date.format("YYYY-MM-DD"));

      if (res.status && res.data.length) {
        const structured = res.data[0].data.map((entry, idx) => ({
          id: entry.id || idx,
          check_in_time: entry.check_in_time,
          check_out_time: entry.check_out_time,
          breaks: entry.breaks || [],
        }));

        setHistoryData(structured);

        const allLogs = [];
        structured.forEach((entry) => {
          (entry.breaks || []).forEach((log, logIdx) => {
            allLogs.push({
              id: `${entry.id}-${logIdx}`,
              parentId: entry.id,
              status: log.status || log.type || "Break",
              activity: log.activity || "",
              log_time: log.log_time,
              duration: log.duration,
            });
          });
        });
        setBreakHistory(allLogs);
      } else {
        setHistoryData([]);
        setBreakHistory([]);
      }

      setDrawerOpen(true);
    } catch (err) {
      console.error("Failed to fetch history:", err);
      message.error("Failed to fetch history");
    }
  };

  useEffect(() => {
    fetchAttendance(selectedDate, activeTab);
    fetchUserLeaveData();
  }, [selectedDate, activeTab]);

  const getPaymentStatusForLeave = (leaveType) => {
    const leave = userLeaveData.find(l => l.leave_type === leaveType && l.status.toLowerCase() === "active");
    return leave ? leave.payment_status : "Unpaid";
  };


  const summaryCardStyle = {
    flex: 1,
    padding: 16,
    borderRadius: 12,
    backgroundColor: "#fff",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };

  const drawerCardStyle = {
    borderRadius: 12,
    padding: 24,
    boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    gap: 12,
  };

  const logItemStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 0",
    borderBottom: "1px dashed #e6f7ff",
  };

  const dateCardStyle = {
    padding: "8px 16px",
    borderRadius: 12,
    backgroundColor: "#e6f7ff",
    display: "inline-block",
    marginBottom: 16,
    fontWeight: 500,
    fontSize: 16,
    color: "#0050b3",
  };

  return (
    <>
      <Card
        title={
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span>Attendance Report</span>
            <Button
              type="primary"
              onClick={() => {

                const approvedPaidLeaves = userLeaveData.filter(
                  (l) =>
                    l.leave_type &&
                    l.payment_status === "Paid" &&
                    l.status === "Approve"
                );


                const extraData = {
                  leaves: approvedPaidLeaves.map((l) => ({
                    leave_type: l.leave_type,
                    payment_status: l.payment_status,
                    status: l.status,
                    from_date: l.from_date,
                    to_date: l.to_date,
                  })),
                };


                const navigateData = {
                  user_id: empUid,
                  name,
                  departmentId,
                  addedBy,
                  department,
                  phone,
                  status,
                  month: selectedDate.format("YYYY-MM"),
                  ...extraData,
                };

                console.log("Navigating with data:", navigateData);


                navigate("/workforce-management/actions/salary-issues", {
                  state: navigateData,
                });
              }}
            >
              Generate Salary
            </Button>

          </div>
        } // bordered
        
      >
        <Tabs
          activeKey={activeTab}
          onChange={(key) => setActiveTab(key)}
          items={["day", "month", "year"].map((tab) => ({
            key: tab,
            label: tab.charAt(0).toUpperCase() + tab.slice(1),
            children: (
              <>
                <DatePicker
                  value={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  style={{ width: 200, marginBottom: 16 }}
                  format={tab === "day" ? "YYYY-MM-DD" : undefined}
                  picker={tab !== "day" ? tab : undefined}
                  allowClear
                />
                <div style={{ display: "flex", gap: 16, marginBottom: 16 }}>
                  <div style={summaryCardStyle}>
                    <Text type="secondary">Total Working Hours</Text>
                    <Text strong style={{ fontSize: 20, marginTop: 8 }}>{summary.totalWorkingHours}</Text>
                  </div>
                  <div style={summaryCardStyle}>
                    <Text type="secondary">Total Break</Text>
                    <Text strong style={{ fontSize: 20, marginTop: 8 }}>{summary.totalBreak}</Text>
                  </div>
                </div>
                <Table dataSource={dataSource} columns={columns} pagination={false} />
              </>
            ),
          }))}
        />
      </Card>



      <Drawer
        title="Attendance Details"
        placement="right"
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        width={500}
        closeIcon={<CloseOutlined />}
        bodyStyle={{ padding: 24, display: "flex", flexDirection: "column", gap: 24 }}
      >

        <div style={{ textAlign: "center" }}>
          <div style={dateCardStyle}>
            {drawerDate ? drawerDate.format("dddd, MMMM D, YYYY") : "-"}
          </div>
        </div>


        <DatePicker
          value={drawerDate}
          onChange={(date) => {
            setDrawerDate(date);
            fetchHistoryByDate(date);
          }}
          style={{ marginBottom: 16, width: "100%" }}
          allowClear={false}
        />


        <div style={drawerCardStyle}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16, marginBottom: 12 }}>
            <Text strong>Check-In</Text>
            <Text strong>Check-Out</Text>
            <Text strong>Duration</Text>
          </div>

          {historyData.length === 0 ? (
            <Text type="secondary">No check-in/out data found.</Text>
          ) : (
            <>
              {historyData.map((entry, index) => {
                const checkIn = new Date(entry.check_in_time);
                const checkOut = entry.check_out_time ? new Date(entry.check_out_time) : new Date();
                const breakSeconds = entry.breaks?.reduce((acc, br) => acc + (br.duration || 0), 0) || 0;
                const workSeconds = Math.max((checkOut - checkIn) / 1000 - breakSeconds, 0);
                const hours = Math.floor(workSeconds / 3600);
                const minutes = Math.floor((workSeconds % 3600) / 60);
                const durationStr = `${hours > 0 ? hours + "h " : ""}${minutes}m`;

                return (
                  <div
                    key={index}
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr",
                      gap: 16,
                      padding: "8px 0",
                      borderBottom: "1px dashed #e6f7ff",
                    }}
                  >
                    <Text>{checkIn.toLocaleTimeString([], { hour12: false })}</Text>
                    <Text>{entry.check_out_time ? checkOut.toLocaleTimeString([], { hour12: false }) : "Ongoing"}</Text>
                    <Text>{durationStr}</Text>
                  </div>
                );
              })}



              {(() => {
                const totalSeconds = historyData.reduce((sum, entry) => {
                  const checkIn = new Date(entry.check_in_time);
                  const checkOut = entry.check_out_time ? new Date(entry.check_out_time) : new Date();
                  const breakSeconds = entry.breaks?.reduce((acc, br) => acc + (br.duration || 0), 0) || 0;
                  const workSeconds = Math.max((checkOut - checkIn) / 1000 - breakSeconds, 0);
                  return sum + workSeconds;
                }, 0);



                const totalHours = Math.floor(totalSeconds / 3600);
                const totalMinutes = Math.floor((totalSeconds % 3600) / 60);

                return (
                  <div
                    style={{
                      marginTop: 12,
                      paddingTop: 8,
                      borderTop: "2px solid #1890ff",
                      textAlign: "right",
                    }}
                  >
                    <Text strong>Total Worked Time: </Text>
                    <Text type="success" strong>
                      {totalHours}h {totalMinutes}m
                    </Text>
                  </div>
                );
              })()}
            </>
          )}
        </div>


        <div style={drawerCardStyle}>
          <Text strong style={{ fontSize: 16, marginBottom: 12 }}>
            Log History
          </Text>
          {breakHistory.length === 0 ? (
            <Text type="secondary">No logs found.</Text>
          ) : (
            <>
              {breakHistory.map(({ id, status, log_time, activity, duration }) => {
                const logTimeFormatted = new Date(log_time).toLocaleTimeString([], { hour12: false });
                let durationStr = "-";
                if (duration && status !== "activity") {
                  const hours = Math.floor(duration / 3600);
                  const minutes = Math.floor((duration % 3600) / 60);
                  durationStr = `${hours > 0 ? hours + "h " : ""}${minutes}m`;
                }

                return (
                  <div key={id} style={logItemStyle}>
                    <Text>{activity || status}</Text>
                    <div style={{ display: "flex", gap: 16 }}>
                      <Text type="secondary">{logTimeFormatted}</Text>
                      {status !== "activity" && <Text type="secondary">{durationStr}</Text>}
                    </div>
                  </div>
                );
              })}


              {(() => {
                const totalBreakSeconds = breakHistory.reduce((sum, { duration }) => sum + (duration || 0), 0);
                const totalBreakHours = Math.floor(totalBreakSeconds / 3600);
                const totalBreakMinutes = Math.floor((totalBreakSeconds % 3600) / 60);

                return (
                  <div
                    style={{
                      marginTop: 12,
                      paddingTop: 8,
                      borderTop: "2px solid #ffa940",
                      textAlign: "right",
                    }}
                  >
                    <Text strong>Total Break Time: </Text>
                    <Text type="danger" strong>
                      {totalBreakHours}h {totalBreakMinutes}m
                    </Text>
                  </div>
                );
              })()}
            </>
          )}
        </div>
      </Drawer>
    </>
  );
}

export default AttendanceReport
